<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css">

<ng-container *ngIf="!hide">
  <div class="float" *ngIf="getIsValidTime()">
    <a [href]="whats" target="_blank" rel="noopener">
      <em class="fa fa-whatsapp my-float"></em>
      <p  class="texto"> ¿Te podemos ayudar? </p>
    </a>
  </div>
</ng-container>
